// ---------------------------------------------------------------------------
// PageError — Standardised error card for hook-level errors.
//
// Usage:
//   const { error } = useGraders();
//   if (error) return <PageError error={error} />;
// ---------------------------------------------------------------------------

import { Body1, Card, Subtitle1, tokens } from '@fluentui/react-components';

import type { PageErrorProps } from './PageError.interface';

export function PageError({
  error,
  title = 'Something went wrong',
}: PageErrorProps) {
  const appError = error as { code?: string };
  const code = appError.code;

  return (
    <Card
      style={{
        maxWidth: 480,
        margin: 'auto',
        marginTop: tokens.spacingVerticalXXXL,
        padding: tokens.spacingHorizontalXL,
      }}
    >
      <Subtitle1>{title}</Subtitle1>
      <Body1 style={{ color: tokens.colorNeutralForeground2 }}>
        {error.message}
      </Body1>
      {code && (
        <Body1
          style={{
            color: tokens.colorNeutralForeground3,
            fontSize: tokens.fontSizeBase200,
            fontFamily: 'monospace',
          }}
        >
          Code: {code}
        </Body1>
      )}
    </Card>
  );
}
